import { IContractValue } from "@components/global/new/ContractSelector/ContractSelector.props";
import { IContractFile } from "@services/contracts";

export enum ActionContractTypes {
  SET_CONTRACTS = "SET_CONTRACTS",
  DELETE_CONTRACT = "DELETE_CONTRACT",
  EDIT_CONTRACT = "EDIT_CONTRACT",
  ADD_CONTRACT = "ADD_CONTRACT",
  ADD_CONTRACT_FILE = "ADD_CONTRACT_FILE",
}

export interface ActionContractBase {
  type: ActionContractTypes;
  payload?: any;
}

export interface ActionSetContracts extends ActionContractBase {
  readonly payload: IContractValue[];
}

export interface ActionContractDelete extends ActionContractBase {
  readonly payload: IContractValue["id"];
}

export interface ActionContractEdit extends ActionContractBase {
  readonly payload: IContractValue;
}

export interface ActionContractAdd extends ActionContractBase {
  readonly payload: IContractValue;
}
export interface ActionAddFileContract extends ActionContractBase {
  readonly payload: IContractFile;
}
